import { render, staticRenderFns } from "./geografis.vue?vue&type=template&id=64eee4e6&"
import script from "./geografis.vue?vue&type=script&lang=js&"
export * from "./geografis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports